/**
 * Shared formatting utilities for currency and numeric display.
 */

export const formatCurrency = (value) => `$${parseFloat(value || 0).toFixed(2)}`;

export const formatHours = (value) => parseFloat(value || 0).toFixed(2);

// Pay amounts the server withheld (caller lacks View pay rates) arrive as
// null/undefined: show a dash, never a misleading $0.00.
export const formatPay = (value) => (value === null || value === undefined ? '—' : formatCurrency(value));
